import { AbstractControl } from '@angular/forms'

export function getValidationMessage(ctrl: AbstractControl, label: string): string | undefined {
  if (!ctrl.invalid) {
    return
  }

  if (ctrl.hasError('required')) {
    return `${label} ` + $localize`is required`
  }

  if (ctrl.hasError('email')) {
    return `${label} ` + $localize`is invalid`
  }

  if (ctrl.hasError('phone')) {
    return `${label} ` + $localize`is invalid`
  }

  if (ctrl.hasError('number')) {
    return $localize`Only number values are allowed.`
  }

  if (ctrl.hasError('integer')) {
    return $localize`Only integer values are allowed.`
  }

  if (ctrl.hasError('minlength')) {
    const minLength = ctrl.errors.minlength.requiredLength
    return $localize`Minimum length is` + ` ${minLength} ` + $localize`characters.`
  }

  if (ctrl.hasError('maxlength')) {
    const maxLength = ctrl.errors.maxlength.requiredLength
    return $localize`Maximum length is` + ` ${maxLength} ` + $localize`characters.`
  }

  if (ctrl.hasError('min')) {
    const min = ctrl.errors.min.min ?? ctrl.errors.min
    return $localize`Minimum value is` + ` ${min}.`
  }

  if (ctrl.hasError('max')) {
    const max = ctrl.errors.max.max ?? ctrl.errors.max
    return $localize`Maximum value is` + ` ${max}.`
  }

  if (ctrl.hasError('url')) {
    return $localize`Invalid url format.`
  }

  if (ctrl.hasError('percent')) {
    return $localize`Value should be greater than 0 and less than 100`
  }

  if (ctrl.hasError('positive')) {
    return $localize`Value should be greater than 0`
  }
}
